import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input, Textarea } from "../../../../ui/inputs/Input";
import { Mensaje } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import { formatMoneda, parseMoneda } from '../../../../util/varios';

export default function Cargos({ show, onHideCancelar, operacion, id, onRecargar }) {
  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  // Estado del formulario
  const [formData, setFormData] = useState({
    codigo: '',
    descripcion: '',
    sueldo: '',
    grado: ''
  });

  // Función para formatear moneda
  const formatearMoneda = (valor) => {
    if (!valor) return '0,00';
    // Eliminar cualquier carácter que no sea número
    let numeros = valor.toString().replace(/\D/g, '');
    if (numeros === '') return '0,00';

    // Convertir a número y formatear
    let numero = parseInt(numeros) / 100;
    return numero.toLocaleString('es-VE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // Convertir formato moneda a número
  const parseMonedaToNumber = (valor) => {
    if (!valor) return 0;
    // Eliminar puntos y reemplazar coma por punto
    let limpio = valor.toString().replace(/\./g, '').replace(',', '.');
    return parseFloat(limpio);
  };

  // Cargar datos si es edición, consulta o eliminación
  useEffect(() => {
    if (show && (operacion === 2 || operacion === 3 || operacion === 4) && id) {
      cargarCargo();
    } else if (show && operacion === 1) {
      // Para inclusión, obtener el último código
      obtenerUltimoCodigo();
    }
  }, [show, id, operacion]);

  const obtenerUltimoCodigo = async () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina.replace(/"/g, '');


    let campos = "MAX(codcar) as ultimo";
    let nomtab = `nomi${codigoNomina}`;
    let orden = "codcar  DESC LIMIT 1";

    let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);
    try {
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200 && response.data.length > 0) {
        console.log(response.data)
        let ultimoCodigo = response.data[0].ultimo || 0;
        let nuevoCodigo = String(parseInt(ultimoCodigo) + 1).padStart(3, '0');
        setFormData(prev => ({
          ...prev,
          codigo: nuevoCodigo.trim()
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          codigo: '001'
        }));
      }
    } catch (error) {
      console.error('Error al obtener último código:', error);
      setFormData(prev => ({
        ...prev,
        codigo: '001'
      }));
    } finally {
      setActivate(false);
    }
  };

  const cargarCargo = async () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina.replace(/"/g, '');

    setActivate(true);
    try {
      const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=nomi${codigoNomina}.cargo&condi=codcar='${id}'&orden=codcar`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200 && response.data.length > 0) {
        const cargo = response.data[0];
        // Formatear sueldo
        let sueldoFormateado = '0,00';
        if (cargo.sueldo) {
          const sueldoNum = parseFloat(cargo.sueldo);
          sueldoFormateado = sueldoNum.toLocaleString('es-VE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }

        setFormData({
          codigo: cargo.codcar ? cargo.codcar.trim() : '',
          descripcion: cargo.nomcar ? cargo.nomcar.trim() : '',
          sueldo: sueldoFormateado,
          grado: cargo.grado ? cargo.grado.trim() : ''
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || 'Error al cargar cargo',
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'sueldo') {
      // Formatear el sueldo mientras el usuario escribe
      let valorFormateado = formatearMoneda(value);
      setFormData(prev => ({
        ...prev,
        [name]: valorFormateado
      }));
    } else if (name === 'grado') {
      // Solo permitir números
      const soloNumeros = value.replace(/\D/g, '');
      // Limitar a 2 caracteres
      const valorLimitado = soloNumeros.slice(0, 2);
      setFormData(prev => ({
        ...prev,
        [name]: valorLimitado
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const validarCampos = () => {
    // Aplicar trim a todos los campos antes de validar
    const codigoTrim = formData.codigo.trim();
    const descripcionTrim = formData.descripcion.trim();
    const sueldoTrim = formData.sueldo.trim();
    const gradoTrim = formData.grado.trim();

    if (!codigoTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El código es requerido', icono: 'informacion' });
      return false;
    }
    if (parseInt(codigoTrim) === 0) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El código no puede ser cero', icono: 'informacion' });
      return false;
    }
    if (!descripcionTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'La descripción es requerida', icono: 'informacion' });
      return false;
    }
    if (!gradoTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El grado es requerido', icono: 'informacion' });
      return false;
    }
    return true;
  };

  const guardarCargo = async () => {
    if (!validarCampos()) return;

    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina.replace(/"/g, '');

    // Aplicar trim a todos los campos antes de enviar
    const codigoTrim = formData.codigo.trim();
    const descripcionTrim = formData.descripcion.trim();
    const gradoTrim = formData.grado.trim();

    // Convertir sueldo a número (remover formato)
    let sueldoNumero = parseMonedaToNumber(formData.sueldo);

    setActivate(true);

    try {
      const endpoint = `${op.conexion}/api/nomina/cargo_act`;

      const data = {
        operacion: operacion, // 1: incluir, 2: editar
        ccodcar: codigoTrim,
        cnomcar: descripcionTrim.toUpperCase(),
        nsueldo: sueldoNumero,
        cgrado: gradoTrim,
        esquema1: `nomi${codigoNomina}`
      };

      const response = await axios.post(endpoint, data, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: `Cargo ${operacion === 1 ? 'incluido' : 'actualizado'} correctamente`,
          icono: 'exito'
        });
        // Recargar tabla
        if (onRecargar) onRecargar();
        // Cerrar modal después de 1.5 segundos
        setTimeout(() => {
          salir();
        }, 1500);
      }
    } catch (error) {
      console.error('Error al guardar cargo:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || 'Error al guardar cargo',
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const eliminarCargo = async () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina.replace(/"/g, '');

    setActivate(true);
    try {
      const endpoint = `${op.conexion}/api/nomina/cargo_act`;

      const data = {
        operacion: 3, // operación 3 = eliminar
        ccodcar: id ? id.trim() : '',
        cnomcar: '',
        nsueldo: 0,
        cgrado: '',
        esquema1: `nomi${codigoNomina}`
      };

      const response = await axios.post(endpoint, data, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: 'Cargo eliminado correctamente',
          icono: 'success'
        });
        if (onRecargar) onRecargar();
        setTimeout(() => {
          salir();
        }, 1500);
      }
    } catch (error) {
      console.error('Error al eliminar cargo:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || 'Error al eliminar cargo',
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const salir = () => {
    setFormData({
      codigo: '',
      descripcion: '',
      sueldo: '',
      grado: ''
    });
    onHideCancelar()
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (operacion === 3) {
      eliminarCargo();
    } else {
      guardarCargo();
    }
  };

  const getTitulo = () => {
    switch (operacion) {
      case 1: return 'Incluir Cargo';
      case 2: return 'Editar Cargo';
      case 3: return 'Eliminar Cargo';
      case 4: return 'Consultar Cargo';
      default: return 'Actualizar Cargos';
    }
  };

  const camposDeshabilitados = () => {
    if (operacion === 3 || operacion === 4) return true;
    return false;
  };

  return (
    <>
      <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
        <form onSubmit={handleSubmit}>
          <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
            <h3 className="fw-bold m-0">{getTitulo()}</h3>
            <a type="button" className="fw-bold text-light fs-6" onClick={salir} style={{ cursor: 'pointer' }}>
              Salir <i className="fa fa-times ms-2"></i>
            </a>
          </Modal.Header>
          <Modal.Body className="col-12 m-0 p-2">
            <fieldset className="col-12 m-0 mb-2 p-2 d-flex flex-wrap border rounded" style={{ borderColor: '#055182' }}>
              <legend className="float-none w-auto m-0 px-2" style={{ fontSize: '1rem', width: 'auto' }}>Datos del Cargo</legend>
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Código:"
                  name="codigo"
                  value={formData.codigo}
                  onChange={handleChange}
                  disabled={camposDeshabilitados() || operacion === 2}
                  required
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea
                  label="Descripción:"
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  disabled={camposDeshabilitados()}
                  style={{ height: 70 }}
                  required
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Sueldo:"
                  name="sueldo"
                  value={formData.sueldo}
                  onChange={handleChange}
                  disabled={camposDeshabilitados()}
                  required
                  inputClassName='text-end'
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Grado:"
                  name="grado"
                  value={formData.grado}
                  onChange={handleChange}
                  disabled={camposDeshabilitados()}
                  maxLength={2}
                  required
                  inputClassName='text-end'

                />
              </div>
            </fieldset>
          </Modal.Body>
          <Modal.Footer>
            {operacion !== 4 && (
              <SuccessButton type="submit">
                {operacion === 3 ? 'Eliminar' : 'Aceptar'}
              </SuccessButton>
            )}
            <DangerButton type="button" onClick={salir}>
              Cancelar
            </DangerButton>
          </Modal.Footer>
        </form>
      </Modal>

      <Dimmer active={activate} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })}
      />
    </>
  );
}